import { ParamLessBaseNetworkSopNode } from "./_BaseManager";
import { NodeContext, NetworkNodeType } from "../../poly/NodeContext";
export class CopNetworkSopNode extends ParamLessBaseNetworkSopNode {
  constructor() {
    super(...arguments);
    this._childrenControllerContext = NodeContext.COP;
  }
  static type() {
    return NetworkNodeType.COP;
  }
  createNode(node_class, options) {
    return super.createNode(node_class, options);
  }
  children() {
    return super.children();
  }
  nodesByType(type) {
    return super.nodesByType(type);
  }
}
